import React from 'react'

export default function MostSearchedSkeleton({ count = 6 }: { count?: number }) {
    return (
        <div className="space-y-3">
            <div className="h-4.5 max-w-52 w-3/5 bg-muted-color/60 rounded animate-pulse" aria-hidden />
            <div className="flex flex-wrap gap-1.5 md:gap-2">
                {Array.from({ length: count }).map((_, i) => (
                    <div
                        key={i}
                        className={`animate-pulse bg-muted-color rounded-full shrink-0 h-7 md:h-8 ${i % 3 === 0 ? 'w-14' : i % 3 === 1 ? 'w-20' : 'w-18'}`}
                        aria-hidden
                    />
                ))}
            </div>
        </div>
    )
}
